

import axios from "axios";
import { StatusCodes } from "http-status-codes";

import * as Error from "./Errores";

export default class ServicioAPI{
    
    constructor(){
        this.controller=new AbortController();
    }

    async ejecutar(input) {
        try {
            const respAxiosExito = await this.hacerRequerimientoAxios(input);
            return this.getDataDeRespuestaAxiosExitosa(respAxiosExito);
        } catch (error) {

            if (axios.isCancel(error)) {
                throw new Error.ErrorCancelacion();
                // console.log('Request canceled', error.message);
            } 
            if (error.hasOwnProperty("isAxiosError") && error.isAxiosError) {
                this.lanzarErrorDeRespuestaAxiosErronea(error);
            }
            if (error instanceof Error.ErrorDeProtocoloDelServidor) {
                throw error;
            }
        }
    }

    cancelar(){
        this.controller.abort();
    }

    /**@abstract */
    async hacerRequerimientoAxios(input){}

    /**@abstract */
    getDataDeRespuestaAxiosExitosa(respAxiosExito){}

    /**@abstract */
    lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios){}


    lanzarErrorDeRespuestaAxiosErronea(errorAxios){
        const respAxiosError = errorAxios.request;

        this.lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios);

        if (respAxiosError.status === StatusCodes.UNPROCESSABLE_ENTITY) {
            //Se parsea respuestaApiComoString
            const respuestaApiComoString = respAxiosError.response;
    
            let keyError=null;
            try {
                const respuestaApi = JSON.parse(respuestaApiComoString);
                keyError = respuestaApi.data.key;    
            } catch (error) {
                throw new Error.ErrorDeProtocoloDelServidor();
            }
    
            if (keyError === "errSesionIdVacia") {
                throw new Error.ErrorEnIdSesion();
            }
            if (keyError === "errSesionIdNoVal") {
                throw new Error.ErrorEnIdSesion();
            }
            throw new Error.ErrorDeProtocoloDelServidor();
    
        }

        if (respAxiosError.status === StatusCodes.BAD_REQUEST) {
            const respuestaApiComoString = respAxiosError.response;

            let keyError=null;
            try {
                const respuestaApi = JSON.parse(respuestaApiComoString);
                keyError = respuestaApi.data.key;    
            } catch (error) {
                throw new Error.ErrorDeProtocoloDelServidor();
            }

            if (keyError === "errSesionNoEnv") {
                throw new Error.ErrorEnIdSesion();
            }

            if (keyError === "errBodyMF") {
                throw new Error.ErrorDeProtocoloDelCliente();
            }
            

            //parsear respuestaApiComoString de tal manera que existan los atributos aceptables “key”: "errReqMF", y otros
            //Si hay error en parseo de esos keys:
            // throw new Error.ErrorDeProtocoloDelCliente();
            
            throw new Error.ErrorDeProtocoloDelServidor();
        }

        if (respAxiosError.status === StatusCodes.NOT_FOUND) {
            const respuestaApiComoString = respAxiosError.response;

            //parsear respuestaApiComoString de tal manera que existan los atributos aceptables “key”: "errPathMF", y otros
            //Si hay error en parseo:
            // throw new Error.ErrorDeProtocoloDeServidor();

            throw new Error.ErrorDeProtocoloDelCliente();
        }

        if (respAxiosError.status === StatusCodes.INTERNAL_SERVER_ERROR) {
            const respuestaApiComoString = respAxiosError.response;

            //parsear respuestaApiComoString de tal manera que existan los atributos aceptables “key”: "errFlujoTrab", y otros
            //Si hay error en parseo:
            // throw new Error.ErrorDeProtocoloDeServidor();

            throw new Error.ErrorDelFlujoDeTrabajoDelBackend();
        }

        // Para los restastes HTTP Codes se debe lanzar un ErrorDesconocidoDelServidor
        if (respAxiosError.status) {
            throw new Error.ErrorDeProtocoloDelServidor();
        }
        // Cuando no se puede conectar al servidor entonces respAxiosError.status === 0, debido a que no se recibio ninguna respuesta
        throw new Error.ErrorNoConex();
    }


}
